//sepori-services/packages/shared/src/logger.ts

import pino, { LoggerOptions, Logger } from 'pino';

// Check if we're in a Node.js environment
const isNode = typeof process !== 'undefined' && process.env;

// Browser-safe environment detection
const isProd = isNode ? process.env.NODE_ENV === 'production' : false;
const pretty = isNode ? !!process.env.LOG_PRETTY && !isProd : false;
const level = isNode ? (process.env.LOG_LEVEL || (isProd ? 'info' : 'debug')) : 'info';

let options: LoggerOptions = {
  level,
  redact: { paths: ['env.ALCHEMY_KEY', 'env.RPC_BASE_URL', 'req.headers.authorization'], remove: true }
};

if (pretty) {
  options = {
    ...options,
    transport: {
      target: 'pino-pretty',
      options: { translateTime: 'SYS:standard', ignore: 'pid,hostname' }
    }
  };
}

export const logger = pino(options);
export type { Logger };
